const RouteShippingStatusEnum = {
  ENTREGADOR_NAO_ATENDIDO: {
    id: 1,
    message: "A entrega não pode ser efetuada - Entregador não atendido",
    name: "Entregador não atendido"
  },
  CLIENTE_DESCONHECIDO: {
    id: 2,
    message: "A entrega não pode ser efetuada - Cliente desconhecido no local",
    name: "Cliente desconhecido"
  },
  CLIENTE_MUDOU: {
    id: 3,
    message: "A entrega não pode ser efetuada - Cliente mudou-se",
    name: "Cliente mudou-se"
  },
  CLIENTE_RECUSOU: {
    id: 4,
    message: "A entrega não pode ser efetuada - Cliente recusou-se a receber",
    name: "Cliente recusou a entrega"
  },
  CLIENTE_SEM_DOCUMENTO: {
    id: 5,
    message: "A entrega não pode ser efetuada - Destinatário não apresentou documento exigido",
    name: "Cliente sem documento"
  },
  EMPRESA_SEM_EXPEDIENTE: {
    id: 6,
    message: "A entrega não pode ser efetuada - Empresa sem expediente",
    name: "Empresa sem expediente"
  },
  ENDERECO_INCORRETO: {
    id: 7,
    message: "A entrega não pode ser efetuada - Endereço incorreto",
    name: "Endereço incorreto"
  },
  ENDERECO_COM_NUMERACAO_IRREGULAR: {
    id: 8,
    message: "A entrega não pode ser efetuada - Logradouro com numeração irregular",
    name: "Numeração irregular"
  },
  EXTRAVIADO: {
    id: 9,
    message: "Objeto Extraviado",
    name: "Objeto extraviado"
  },
  ENTREGUE: {
    id: 11,
    message: "Objeto entregue ao destinatário",
    name: "Objeto entregue"
  },
  PENDENTE: {
    id: 12,
    message: "Pendente",
    name: "Objeto pendente"
  },
  EM_ROTA_DE_ENTREGA: {
    id: 13,
    message: "O objeto está em rota de entrega",
    name: "Em rota de entrega"
  },
  ENTREGADOR_NAO_FINALIZOU_ENTREGA: {
    id: 14,
    message: "A entrega não pode ser efetuada - O entregador não finalizou a entrega",
    name: "Entrega não finalizada"
  },
  AREA_DE_RISCO: {
    id: 15,
    message: "A entrega não pode ser efetuada - Área de risco",
    name: "Objeto em área de risco"
  },
  SEM_ACESSO_AO_LOCAL: {
    id: 20,
    message: "A entrega não pode ser efetuada - Impossibilidade de acesso ao local",
    name: "Sem acesso ao local"
  },
  PROBLEMA_NO_VEICULO: {
    id: 21,
    message: "A entrega não pode ser efetuada - Problema no veículo",
    name: "Problema no veículo"
  },
  REMETENTE_SOLICITOU_DEVOLUCAO: {
    id: 22,
    message: "A entrega não pode ser efetuada - Pedido devolvido por solicitação do remetente",
    name: "Remetente solicitou devolução"
  },
};

export { RouteShippingStatusEnum }